export const MATERIAL_ITEM_TYPE = "MATERIAL_ITEM_TYPE";
